import SettingsIcon from "@material-ui/icons/Settings";
import React from "react";
import { MenuItemLink, UserMenu } from "react-admin";

const MyUserMenu = (props) => {
  return (
    <UserMenu {...props}>
      <MenuItemLink
        to="/api/user/changeMyPassword"
        primaryText="Mot de passe"
        leftIcon={<SettingsIcon />}
      />
    </UserMenu>
  );
};

export default MyUserMenu;